import MantMaestros from './MantMaestros';
import MaestroNuevo from './MaestroNuevo';

export default {
  route: {
    index : {
      path: '/mantenimiento-maestros/:save',
      component: MantMaestros
    },
    index2 : {
      path: '/mantenimiento-maestros',
      component: MantMaestros
    },
    nuevo : {
      path: '/mantenimiento-maestros/nuevo',
      component: MaestroNuevo
    },
    editar : {
      path: '/mantenimiento-maestros/detalle',
      component: MaestroNuevo
    }
  }

};



// WEBPACK FOOTER //
// ./src/pages/MantMaestros/index.js